import clsx from "clsx";

interface Step {
  label: string;
}

interface StepperProps {
  steps: Step[];
  currentStep: number; // 1-based
}

export default function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <nav aria-label="Fortschritt" className="mb-6">
      <ol className="flex items-center gap-0">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isDone = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;

          return (
            <li key={step.label} className="flex items-center flex-1 last:flex-none">
              {/* Schritt-Indikator */}
              <div className="flex flex-col items-center">
                <div
                  className={clsx(
                    "w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold transition-all",
                    isDone && "bg-neko-green text-white",
                    isActive && "bg-neko-orange text-neko-dark ring-2 ring-neko-orange ring-offset-2 ring-offset-neko-dark",
                    !isDone && !isActive && "bg-neko-dark-3 text-neko-gray"
                  )}
                  aria-current={isActive ? "step" : undefined}
                >
                  {isDone ? "✓" : stepNumber}
                </div>
                <span
                  className={clsx(
                    "text-xs mt-1 text-center hidden sm:block",
                    isActive ? "text-neko-orange font-medium" : "text-neko-gray"
                  )}
                >
                  {step.label}
                </span>
              </div>

              {/* Verbindungslinie */}
              {index < steps.length - 1 && (
                <div
                  className={clsx(
                    "h-0.5 flex-1 mx-1 transition-all",
                    stepNumber < currentStep ? "bg-neko-green" : "bg-neko-dark-3"
                  )}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
